// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module_container_2l25B","wrapper":"index-module_wrapper_1D99N","tip-text":"index-module_tip-text_1brPt"};